import script from "./StoreAdminForgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreAdminForgotPassword.vue?vue&type=script&setup=true&lang=js"

import "./StoreAdminForgotPassword.vue?vue&type=style&index=0&id=6df1637b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df1637b"]])

export default __exports__